import { render, staticRenderFns } from "./RolModal.vue?vue&type=template&id=837f6e24&scoped=true&"
import script from "./RolModal.vue?vue&type=script&lang=js&"
export * from "./RolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837f6e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('837f6e24')) {
      api.createRecord('837f6e24', component.options)
    } else {
      api.reload('837f6e24', component.options)
    }
    module.hot.accept("./RolModal.vue?vue&type=template&id=837f6e24&scoped=true&", function () {
      api.rerender('837f6e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/roles/RolModal.vue"
export default component.exports